import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Page from 'flarum/common/components/Page';
import app from 'flarum/forum/app';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Link from 'flarum/common/components/Link';
import MundialTeamVotersModal from './MundialTeamVotersModal';
import NagusiBackNav from '../common/NagusiBackNav';
export default class MundialTeamsPage extends Page {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "teams", []);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.loadData();
  }
  loadData() {
    this.loading = true;
    app.request({
      method: 'GET',
      url: app.forum.attribute('apiUrl') + '/nagusi/match-ratings/mundial-teams'
    }).then(response => {
      this.teams = app.store.pushPayload(response) || [];
      this.loading = false;
      m.redraw();
    }).catch(() => {
      this.loading = false;
      m.redraw();
    });
  }
  showVoters(team) {
    app.modal.show(MundialTeamVotersModal, {
      team
    });
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "BolillaPage"
      }, m(LoadingIndicator, null));
    }
    return m("div", {
      className: "BolillaPage"
    }, m("div", {
      className: "container"
    }, m(NagusiBackNav, {
      parentUrl: "/aurrera-jokoak",
      parentLabel: "Aurrera Jokoak",
      title: "Mundial 2026"
    }), m("h2", {
      className: "BolillaPage-Title"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.porrita_title')), m("div", {
      className: "JokoakSubmenu",
      style: "display: flex; gap: 15px; margin-bottom: 25px; justify-content: center; background: #fff; padding: 10px; border-radius: 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.04); border: 1px solid rgba(0,0,0,0.06);"
    }, m(Link, {
      href: "/mundial-2026/clasificacion",
      className: "JokoakSubmenu-link",
      style: "padding: 8px 20px; border-radius: 20px; font-weight: bold; font-size: 13px; text-decoration: none; color: #666; background: transparent; transition: all 0.2s;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.classification_tab')), m(Link, {
      href: "/mundial-2026/selecciones",
      className: "JokoakSubmenu-link active",
      style: "padding: 8px 20px; border-radius: 20px; font-weight: bold; font-size: 13px; text-decoration: none; color: #fff; background: #EE2523; transition: all 0.2s;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.teams_tab'))), m("div", {
      className: "Stats-Main-Content"
    }, m("div", {
      className: "Season-Statistics",
      style: "width: 100%;"
    }, m("div", {
      className: "Top-Players-Full-Table",
      style: "background: #fff; padding: 20px; border-radius: 16px; border: 1px solid rgba(0,0,0,0.08); box-shadow: 0 4px 20px rgba(0,0,0,0.04);"
    }, m("h4", {
      style: "font-weight: 800; font-size: 1.25em; margin: 0 0 15px 0;"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.teams_table_title')), m("div", {
      className: "Table-Wrapper"
    }, m("table", {
      className: "Table"
    }, m("thead", null, m("tr", null, m("th", null, app.translator.trans('nagusi-match-ratings.forum.mundial.team_header')), m("th", {
      className: "center"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.pot_header')), m("th", {
      className: "center"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.points_header')), m("th", {
      className: "center"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.voters_count_header')), m("th", {
      className: "center"
    }, app.translator.trans('nagusi-match-ratings.forum.mundial.details_header')))), m("tbody", null, this.teams.map(team => {
      return m("tr", {
        key: team.id()
      }, m("td", {
        className: "bold",
        style: "font-size: 1.1em; color: #333;"
      }, team.name()), m("td", {
        className: "center"
      }, m("span", {
        style: "background: ".concat(team.pot() === 1 ? '#EE2523' : team.pot() === 2 ? '#EF6C00' : team.pot() === 3 ? '#4CAF50' : '#9C27B0', "; color: #fff; font-size: 0.85em; font-weight: bold; width: 24px; height: 24px; display: inline-flex; align-items: center; justify-content: center; border-radius: 50%;")
      }, team.pot())), m("td", {
        className: "center bold",
        style: "font-size: 1.15em; color: #EE2523;"
      }, team.points()), m("td", {
        className: "center"
      }, m("span", {
        style: "font-size: 11px; color: #777; background: #f0f0f0; padding: 2px 6px; border-radius: 10px; display: inline-flex; align-items: center; gap: 4px; font-weight: normal;"
      }, m("i", {
        className: "fas fa-users",
        style: "font-size: 10px; color: #888;"
      }), " ", team.voteCount() || 0)), m("td", {
        className: "center"
      }, m(Button, {
        className: "Button Button--link",
        onclick: () => this.showVoters(team),
        icon: "fas fa-info-circle"
      }, m("span", {
        className: "Button-label"
      }, app.translator.trans('nagusi-match-ratings.forum.mundial.view_choices')))));
    })))))))));
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/mundial/MundialTeamsPage', MundialTeamsPage);